// extracted by mini-css-extract-plugin
export var collapsed = "ContentNodeCard-module--collapsed---guDx";
export var excerpt = "ContentNodeCard-module--excerpt--hPy4q";